import { render, staticRenderFns } from "./period-selector.vue?vue&type=template&id=b010bd70&"
import script from "./period-selector.vue?vue&type=script&lang=ts&"
export * from "./period-selector.vue?vue&type=script&lang=ts&"
import style0 from "./period-selector.vue?vue&type=style&index=0&id=b010bd70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports